import Const from 'const';
import {LateSwapSettingsInterface} from 'components/organisms/late-swap/late-swap-interfaces';

class LateSwapSettings implements LateSwapSettingsInterface {
    constructor(public readonly used: boolean = false) {}
    isUsed(): boolean {
        return this.used;
    }
}

const lateSwapSettings = new LateSwapSettings();

export default function (state = lateSwapSettings, action) {
    switch (action.type) {
        case Const.LATESWAP_SET_IS_USED:
            return new LateSwapSettings(Boolean(action.use));

        default:
            return state;
    }
}
